import {call, put, select} from "redux-saga/effects";
import {loggingInUser, logOutUser} from "../requests/userService";
import {setLoading, setError, setSuccess} from "../../slices/loginSlice";
import {toast} from "react-toastify";
import {clearToken, setAppLoading} from "../../slices/authTokenSlice";
import {signOut} from "firebase/auth";
import {auth} from "../../../db/firebase";

export function* handleUserLogin(action) {
  try {
    yield put(setLoading(true))
    yield call(()=>loggingInUser(action.payload))
    yield put(setSuccess())
  } catch (error) {
    const errMsg = error.response ?  error.response.data.message :  error.message;
    toast.error(`Error: ${errMsg}`)
    yield put(setError(errMsg))
  }
}

export function* handleUserLogout(action) {
  try {
    yield put(setAppLoading(true))

    const refreshToken = yield select((state) => state.authToken.token.refresh_token)
    yield call(()=>logOutUser(refreshToken))
    yield call(()=>signOut(auth))
    yield put(clearToken())

  } catch (error) {

    const errMsg = error.response ?  error.response.data.message :  error.message;
    toast.error(`Error: ${errMsg}`)
    yield put(setError(errMsg))
  }finally {
    yield put(setAppLoading(false))
  }
}